const PdfSizes = [
  // { value: '100', label: 'sdfsdf', disabled: true },
  { value: '100', label: 'No Change' },
  { value :'iso_a_series',label:'ISO A Series',disabled:true},
  { value: 'a0', label: 'A0', width: 2384, height: 3370 },
  { value: 'a1', label: 'A1', width: 1684, height: 2384  },
  { value: 'a2', label: 'A2', width: 1191, height: 1684  },
  { value: 'a3', label: 'A3' , width: 842, height: 1191 },
  { value: 'a4', label: 'A4' , width: 595, height: 842 },
  { value: 'a4small', label: 'A4 Small', width: 595, height: 842  },
  { value: 'a5', label: 'A5', width: 420, height: 595  },
  { value: 'a6', label: 'A6', width: 297, height: 420  },
  { value: 'a7', label: 'A7' , width: 210, height: 297 },
  { value: 'a8', label: 'A8', width: 148, height: 210  },
  { value: 'a9', label: 'A9' , width: 105, height: 148 },
  { value: 'a10', label: 'A10', width: 73, height: 105  },
  { value :'other_paper _sizes',label:'Other Paper Sizes',disabled:true},
  // { value: 'junior_legal', label: 'Junior Legal' },
  { value: 'letter', label: 'Letter', width: 612, height: 792 },
  { value: 'legal', label: 'Legal' , width: 612, height: 1008},
  { value: 'ledger', label: 'Ledger' , width: 1224, height: 792},
  { value: 'tabloid', label: 'Tabloid', width: 73, height: 105 },
  // { value: 'statement', label: 'Statement' },
  { value: 'arch_series', label: 'Arch Series', disabled:true},
  { value: 'arche', label: 'ArchE', width: 2592, height: 3456},
  { value: 'archd', label: 'ArchD' , width: 1728, height: 2592},
  { value: 'archc', label: 'ArchC' , width: 1296, height: 1728},
  { value: 'archb', label: 'ArchB' , width: 864, height: 1296},
  { value: 'archa', label: 'ArchA' , width: 648, height: 864},
  { value: 'iso_c_series', label: 'ISO C series', disabled:true},
  { value: 'c0', label: 'C0', width: 2599, height: 3677 },
  { value: 'c1', label: 'C1' , width: 1837, height: 2599},
  { value: 'c2', label: 'C2', width: 1298, height: 1837 },
  { value: 'c3', label: 'C3' , width: 918, height: 1298},
  { value: 'c4', label: 'C4', width: 649, height: 918 },
  { value: 'c5', label: 'C5' , width: 459, height: 649},
  { value: 'c6', label: 'C6' , width: 323, height: 459},
  // { value: 'c7', label: 'C7' },
  { value: 'jis_b_series', label: 'JIS B Series', disabled:true},
  { value: 'jisb0', label: 'Jis b0' , width: 2920, height: 4127},
  { value: 'jisb1', label: 'Jis b1' , width: 2064, height: 2920},
  { value: 'jisb2', label: 'Jis b2' , width: 2060, height: 2064},
  { value: 'jisb3', label: 'Jis b3' , width: 1032, height: 2060},
  { value: 'jisb4', label: 'Jis b4' , width: 729, height: 1032},
  { value: 'jisb5', label: 'Jis b5' , width: 516, height: 729},
  { value: 'jisb6', label: 'Jis b6' , width: 363, height: 516},
  { value: 'iso_b_series', label: 'ISO B series', disabled:true},
  { value: 'b0', label: 'B0' , width: 2835, height: 4008 },
  { value: 'b1', label: 'B1'  , width: 2004, height: 2835},
  { value: 'b2', label: 'B2'  , width: 1417, height: 2004},
  { value: 'b3', label: 'B3'  , width: 1000, height: 1417},
  { value: 'b4', label: 'B4'  , width: 707, height: 1000},
  { value: 'b5', label: 'B5'  , width: 499, height: 707},
  // { value: 'b6', label: 'B6' },
]

export default PdfSizes;


// WEBPACK FOOTER //
// ./src/modules/PdfSizes.js